<template>
  <div
    class="selectable-option light-bordered light-radius q-pa-md"
    :class="cardClasses"
    @click="onCardClick"
  >
    <div class="selectable-option__main-row row items-center no-wrap">
      <q-icon :name="indicatorIcon" :class="indicatorClasses" size="1.25rem" class="q-mr-sm" />
      <span class="col text-16 text-font-medium ellipsis" :class="nameTextClass">
        {{ displayName }}
      </span>
    </div>

    <div
      v-if="selected"
      class="selectable-option__creation-options column medium-radius q-py-xs q-px-sm q-mt-sm"
    >
      <q-checkbox
        v-model="fullAiAssessment"
        label="Generate full AI assessment"
        color="brand"
        size="26px"
        :readonly="isLoading"
      />
      <q-checkbox
        v-model="startSubprocessorList"
        :label="CREATE_MODAL_START_SUBPROCESSOR_LIST_LABEL"
        color="brand"
        size="26px"
        :readonly="isLoading"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

import { CREATE_MODAL_START_SUBPROCESSOR_LIST_LABEL } from 'src/services/consts/company.const'

const props = defineProps({
  value: { type: String, default: null },
  emptyText: { type: String, default: null },
  selected: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  isLoading: { type: Boolean, default: false },
})

const fullAiAssessment = defineModel('fullAiAssessment', { type: Boolean, default: false })
const startSubprocessorList = defineModel('startSubprocessorList', {
  type: Boolean,
  default: false,
})

const emit = defineEmits(['select'])

const displayName = computed(() => {
  if (props.disabled && !props.value && props.emptyText) return props.emptyText
  return props.value || ''
})

const cardClasses = computed(() => ({
  'selectable-option--selected': props.selected,
  'selectable-option--disabled': props.disabled,
  'selectable-option--clickable': !props.disabled && !props.isLoading,
}))

const nameTextClass = computed(() => {
  if (props.disabled) return 'text-secondary'
  return 'text-primary'
})

const indicatorIcon = computed(() => {
  if (props.disabled) return 'radio_button_unchecked'
  return props.selected ? 'check_circle' : 'radio_button_unchecked'
})

const indicatorClasses = computed(() => ({
  'text-brand': props.selected && !props.disabled,
  'text-secondary': !props.selected || props.disabled,
}))

const onCardClick = () => {
  if (props.disabled || props.isLoading) return
  emit('select')
}
</script>

<style lang="scss">
@import '/src/css/setup/variables.scss';

.selectable-option {
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease;

  &--clickable {
    cursor: pointer;

    &:not(.selectable-option--selected):hover {
      background-color: $clr-accent-table;
    }
  }

  &--selected {
    border: 2px solid $clr-brand !important;
  }

  &--disabled {
    cursor: not-allowed;
  }
}

.selectable-option__main-row {
  gap: 0.25rem;
}

.selectable-option__creation-options {
  gap: 0;
  background-color: rgba(169, 207, 236, 0.21) !important;

  .q-checkbox__label {
    font-size: 0.75rem;
    color: $clr-primary-light;
  }
}
</style>
